var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_vm.$vuetify.breakpoint.smAndUp ? _c('main-visual', {
    attrs: {
      "code": "main-pc"
    }
  }) : _c('main-visual', {
    attrs: {
      "code": "main-mobile"
    }
  })], 1), _c('main-section', {
    staticClass: "main-section--recruitment"
  }, [_c('main-banner', {
    staticClass: "main-banner--vertical",
    attrs: {
      "code": "main-side-1-pc",
      "pc": "",
      "vertical": ""
    }
  }), _c('main-recruitment-list', _vm._b({
    staticClass: "mb-40 mb-lg-80",
    attrs: {
      "title": "최근 게시된 채용공고"
    }
  }, 'main-recruitment-list', _vm.recruitmentListProps.recent, false)), _c('main-banner', {
    attrs: {
      "code": "main-sub-1-pc",
      "pc": ""
    }
  }), _c('main-banner', {
    attrs: {
      "code": "main-sub-1-mobile",
      "mobile": ""
    }
  }), _c('main-recruitment-list', _vm._b({
    staticClass: "my-40 my-lg-80",
    attrs: {
      "title": "인기 채용공고"
    }
  }, 'main-recruitment-list', _vm.recruitmentListProps.popular, false)), _c('main-banner', {
    attrs: {
      "code": "main-sub-2-pc",
      "pc": ""
    }
  }), _c('main-banner', {
    attrs: {
      "code": "main-sub-2-mobile",
      "mobile": ""
    }
  }), _c('main-recruitment-list', _vm._b({
    staticClass: "mt-40 mt-lg-80",
    attrs: {
      "title": "마감 임박 채용공고"
    }
  }, 'main-recruitment-list', _vm.recruitmentListProps.closing, false))], 1), _c('main-section', {
    staticClass: "grey-f7",
    attrs: {
      "title": "프로필을 등록하고 시작해보세요"
    }
  }, [_c('v-row', {
    staticClass: "my-n14 ma-xl-n54 text-center",
    attrs: {
      "justify": "center"
    }
  }, _vm._l(_vm.visions, function (item) {
    return _c('v-col', {
      key: item.title,
      staticClass: "py-14 pa-xl-54",
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4"
      }
    }, [_c('v-img', {
      staticClass: "w-100 mb-20 mb-lg-40",
      attrs: {
        "src": item.image
      }
    }), _c('h4', {
      staticClass: "font-size-20 font-size-lg-24 mb-8 mb-lg-16"
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), _c('p', {
      staticClass: "page-text--lg grey--text word-keep-all",
      domProps: {
        "innerHTML": _vm._s(item.sc)
      }
    })], 1);
  }), 1), _c('div', {
    staticClass: "mt-40 mt-lg-80"
  }, [_c('v-row', {
    staticClass: "row-cols-md-5",
    attrs: {
      "justify": "center"
    }
  }, _vm._l(_vm.partners, function (item) {
    return _c('v-col', {
      key: item.logo,
      attrs: {
        "cols": "6",
        "sm": "4"
      }
    }, [_c('v-img', {
      staticClass: "w-100 mx-auto",
      attrs: {
        "src": item.logo,
        "max-width": "256",
        "contain": ""
      }
    })], 1);
  }), 1)], 1)], 1), _c('section', {
    staticClass: "main-section--link"
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--main-link v-btn--main-link--left",
    attrs: {
      "to": "/center/faqs",
      "tile": "",
      "block": "",
      "color": "primary"
    }
  }, [_c('i', {
    staticClass: "icon icon-faq"
  }), _c('span', {
    staticClass: "d-inline-block ml-4 ml-lg-8 mr-12 mr-lg-40"
  }, [_vm._v("FAQ")]), _c('i', {
    staticClass: "icon icon-right-arrow-shadow"
  })])], 1), _c('v-col', {
    staticClass: "border-start white",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--main-link v-btn--main-link--right",
    attrs: {
      "href": "/dashboard/queries",
      "tile": "",
      "block": "",
      "color": "primary"
    }
  }, [_c('i', {
    staticClass: "icon icon-question"
  }), _c('span', {
    staticClass: "d-inline-block ml-4 ml-lg-8 mr-12 mr-lg-40"
  }, [_vm._v("1:1 문의")]), _c('i', {
    staticClass: "icon icon-right-arrow-shadow"
  })])], 1)], 1)], 1)], 1), _c('popup-layer')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }